import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { WaterAccountAllocationDraft } from "../models/WaterAccountAllocationDraft";

export const upsertWaterAccountAllocations = async (
	draft: WaterAccountAllocationDraft,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "WaterAccountId", value: draft.WaterAccountId },
		{ name: "IsActive", value: draft.IsActive },
		{
			name: "AllocationsJson",
			value: JSON.stringify(
				draft.Allocations.map((allocation, index) => ({
					TargetId: allocation.TargetId,
					AllocationPercent: allocation.AllocationPercent,
					DisplayOrder: index + 1,
				})),
			),
		},
	];

	const resp = await apiService.callV2(
		"[USG].[UpsertWaterAccount]",
		parameters,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error saving the account split");
	}
};
